import type { ColumnDefinition, PresetConfiguration } from '@/components/column-configurator-modal';

// Resource Budget Column Definitions
export const RESOURCE_BUDGET_COLUMNS: ColumnDefinition[] = [
  {
    id: 'role',
    name: 'Role',
    description: 'Resource role or job title',
    category: 'Resource',
    visible: true,
    locked: true,
    order: 0,
  },
  {
    id: 'budget-hours',
    name: 'Budget (hrs)',
    description: 'Total budgeted hours for this role',
    category: 'Resource',
    visible: true,
    order: 1,
    align: 'right',
  },
  {
    id: 'budget-cost',
    name: 'Budget Cost',
    description: 'Total budgeted cost (hours × rate)',
    category: 'Financial',
    visible: true,
    order: 2,
    align: 'right',
  },
  {
    id: 'actual-hours',
    name: 'Actual (hrs)',
    description: 'Actual hours logged to date',
    category: 'Resource',
    visible: true,
    order: 3,
    align: 'right',
  },
  {
    id: 'actual-cost',
    name: 'Actual Cost',
    description: 'Actual cost incurred to date',
    category: 'Financial',
    visible: true,
    order: 4,
    align: 'right',
  },
  {
    id: 'remaining-hours',
    name: 'Remaining (hrs)',
    description: 'Hours remaining in budget',
    category: 'Resource',
    visible: true,
    order: 5,
    align: 'right',
  },
  {
    id: 'percent-used',
    name: '% Used',
    description: 'Percentage of budget consumed',
    category: 'Performance',
    visible: true,
    order: 6,
    align: 'right',
  },
  {
    id: 'rate',
    name: 'Rate',
    description: 'Billing rate per hour',
    category: 'Financial',
    visible: true,
    order: 7,
    align: 'right',
  },
  {
    id: 'status',
    name: 'Status',
    description: 'Budget health status indicator',
    category: 'Status',
    visible: true,
    order: 8,
  },
  {
    id: 'variance-hours',
    name: 'Variance (hrs)',
    description: 'Difference between actual and budget hours',
    category: 'Performance',
    visible: false,
    order: 9,
    align: 'right',
  },
  {
    id: 'variance-cost',
    name: 'Variance Cost',
    description: 'Cost variance from budget',
    category: 'Financial',
    visible: false,
    order: 10,
    align: 'right',
  },
  {
    id: 'forecast-hours',
    name: 'Forecast (hrs)',
    description: 'Projected total hours at completion',
    category: 'Performance',
    visible: false,
    order: 11,
    align: 'right',
  },
  {
    id: 'forecast-cost',
    name: 'Forecast Cost',
    description: 'Projected total cost at completion',
    category: 'Financial',
    visible: false,
    order: 12,
    align: 'right',
  },
  {
    id: 'efficiency',
    name: 'Efficiency',
    description: 'Resource efficiency rating',
    category: 'Performance',
    visible: false,
    order: 13,
    align: 'right',
  },
];

// Resource Budget Preset Configurations
export const RESOURCE_BUDGET_PRESETS: PresetConfiguration[] = [
  {
    id: 'default',
    name: 'Default View',
    columns: [
      { id: 'role', visible: true },
      { id: 'budget-hours', visible: true },
      { id: 'budget-cost', visible: true },
      { id: 'actual-hours', visible: true },
      { id: 'actual-cost', visible: true },
      { id: 'remaining-hours', visible: true },
      { id: 'percent-used', visible: true },
      { id: 'rate', visible: true },
      { id: 'status', visible: true },
    ],
  },
  {
    id: 'hours-focused',
    name: 'Hours Focused',
    columns: [
      { id: 'role', visible: true },
      { id: 'budget-hours', visible: true },
      { id: 'actual-hours', visible: true },
      { id: 'remaining-hours', visible: true },
      { id: 'percent-used', visible: true },
      { id: 'variance-hours', visible: true },
      { id: 'forecast-hours', visible: true },
      { id: 'status', visible: true },
    ],
  },
  {
    id: 'financial',
    name: 'Financial View',
    columns: [
      { id: 'role', visible: true },
      { id: 'budget-cost', visible: true },
      { id: 'actual-cost', visible: true },
      { id: 'variance-cost', visible: true },
      { id: 'forecast-cost', visible: true },
      { id: 'rate', visible: true },
      { id: 'status', visible: true },
    ],
  },
  {
    id: 'performance',
    name: 'Performance View',
    columns: [
      { id: 'role', visible: true },
      { id: 'percent-used', visible: true },
      { id: 'variance-hours', visible: true },
      { id: 'variance-cost', visible: true },
      { id: 'efficiency', visible: true },
      { id: 'status', visible: true },
    ],
  },
  {
    id: 'compact',
    name: 'Compact View',
    columns: [
      { id: 'role', visible: true },
      { id: 'budget-hours', visible: true },
      { id: 'actual-hours', visible: true },
      { id: 'percent-used', visible: true },
      { id: 'status', visible: true },
    ],
  },
];

// Storage key for resource budget column preferences
export const RESOURCE_BUDGET_STORAGE_KEY = 'resource-budget-column-preferences';
